import { useState, useEffect } from "react";
function usePersistentState(name, defaultValue) {
  const result = useState(() => {
    const currentValue = localStorage[name];
    let newValue;
    try {
      newValue = currentValue ? JSON.parse(currentValue) : defaultValue;
    } catch {
      newValue = defaultValue;
    }
    if (typeof defaultValue === "function") {
      newValue = defaultValue(newValue);
    }
    return newValue;
  });

  const [value] = result;
  useEffect(() => {
    let serialized = JSON.stringify(value);
    if (typeof serialized !== "string") serialized = JSON.stringify(null);
    localStorage[name] = serialized;
  }, [name, value]);
  return result;
}

export default usePersistentState;
